import { render, staticRenderFns } from "./settingTab.vue?vue&type=template&id=48525e00&"
import script from "./settingTab.vue?vue&type=script&lang=js&"
export * from "./settingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48525e00')) {
      api.createRecord('48525e00', component.options)
    } else {
      api.reload('48525e00', component.options)
    }
    module.hot.accept("./settingTab.vue?vue&type=template&id=48525e00&", function () {
      api.rerender('48525e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotScore/tab/settingTab.vue"
export default component.exports